import {charcoal} from '../sass/base/_exports.sass';

export const PencilIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
    >
      <path
        fill={color}
        d="M1.732 31.987q.207.026.413 0l6.886-1.721a1.7 1.7 0 0 0 .81-.447l21.157-21.22a3.443 3.443 0 0 0 0-4.854l-2.72-2.736a3.443 3.443 0 0 0-4.872 0L2.25 22.16a1.8 1.8 0 0 0-.465.809L.062 29.853a1.72 1.72 0 0 0 1.257 2.134q.207.026.413 0M25.834 3.436l2.737 2.736-2.737 2.736-2.72-2.736zM5.02 24.26 20.67 8.599l2.736 2.736L7.74 26.996l-3.632.895z"
      />
    </svg>
  );
};
